import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
export var useAuthStore = defineStore({
  id: "auth",
  state: function state() {
    return {
      user: null
    };
  },
  getters: {
    loggedIn: function loggedIn(state) {
      return Boolean(state.user);
    }
  },
  actions: {
    setUser: function setUser(user) {
      this.user = user;
    },
    patchUser: function patchUser(key, value) {
      this.user[key] = value;
    },
    fetch: function fetch() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var userData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.user) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return _this.$nuxt.$axios.$get('/user/user');
            case 5:
              userData = _context.sent;
              if (userData) _this.setUser(userData);
              _context.next = 13;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);
              _this.user = null;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 9]]);
      }))();
    }
  }
});